export default __webpack_public_path__ + "static/media/arrowOutward.bbecacdf.svg";